export const defaultState = {
  coursenum: '',
  courseTitle: '',
  courseLms: true,
  authorized: false,
  peopleRowData: [],
  archivedRowData: [],
  sectionRowData: [],
  allSectionData: [],
  toBeArchived: [],
  chapterData: [],
  elevatedUser: false,
  videoData: [],
  filters: {},
  peopleCount: 0,
  archivedCount: 0,
  sectionCount: 0,
  currentCourseMemPage: 1,
  currentArchivePage: 1,
  currentSectionPage: 1,
  memPageLimit: 50,
  sectionPageLimit: 20,
}

export const peopleReducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_PEOPLE_DATA':
      return {
        ...state,
        peopleRowData: action.payload,
      }
    case 'UPDATE_ARCHIVED_MEMBERS':
      return {
        ...state,
        archivedRowData: action.payload,
      }
    case 'UPDATE_SECTIONS':
      return {
        ...state,
        sectionRowData: action.payload,
      }
    case 'UPDATE_ALL_SECTIONS':
      return {
        ...state,
        allSectionData: action.payload,
      }
    case 'UPDATE_ACTIVE_COUNT':
      return {
        ...state,
        peopleCount: action.payload,
      }
    case 'UPDATE_ARCHIVED_COUNT':
      return {
        ...state,
        archivedCount: action.payload,
      }
    case 'UPDATE_SECTION_COUNT':
      return {
        ...state,
        sectionCount: action.payload,
      }
    case 'UPDATE_TO_BE_ARCHIVED_MEMBERS':
      return {
        ...state,
        toBeArchived: action.payload,
      }
    case 'UPDATE_COURSE_MEMBER_PAGE':
      return {
        ...state,
        currentCourseMemPage: action.payload,
      }
    case 'UPDATE_ARCHIVED_MEMBER_PAGE':
      return {
        ...state,
        currentArchivePage: action.payload,
      }
    case 'UPDATE_SECTION_PAGE':
      return {
        ...state,
        currentSectionPage: action.payload,
      }
    case 'UPDATE_FILTERS':
      return {
        ...state,
        filters: action.payload,
      }
    case 'RESET_FILTERS':
      return {
        ...state,
        filters: {},
      }
    default:
      return state
  }
}
